import { useRequestCreateCreator, useRequestEditCreator } from '@/hooks/httpRequest';
import { useFormContext, useWatch } from 'react-hook-form';
import { Button, DialogFooter } from '@/components/ui';
import { broadcastService } from '@/services';
import { TFormData, TProps } from '.';
import { notify } from '@/functions';

const FormCreateOrEditCreatorFooter = ({ textBtnCancel, fieldNames, readonly = false, callback }: TProps) => {

  const { trigger: triggerEditCreator, isLoading: isLoadingEditCreator } = useRequestEditCreator();
  const { handleSubmit, setValue, control, formState: { isValid } } = useFormContext<TFormData>();
  const { trigger: triggerCreate, isLoading: isLoadingCreate } = useRequestCreateCreator();
  const links = useWatch({ control, name: fieldNames?.links! as any }) as string[] ?? [];

  const handleOnClickBtnCancel = () => {
    // Close form
    broadcastService.modal.hide();
    // Call callback function
    callback?.({ event: 'canceled' });
  };

  const handleOnClickBtnSave = () =>
    handleSubmit(
      async data => {
        try {
          let notificationMessage = 'Le créateur a été enregistrée avec succès';
          // Save 
          if (data._id) {
            await
              triggerEditCreator(data as any)
                .catch(error => { throw new Error(error?.internalMessage); });
            notificationMessage = 'Le créateur a été modifiée avec succès';
          }
          else {
            const userId = (
              await
                triggerCreate(data)
                  .catch(error => { throw new Error(error?.internalMessage); })
            );

            data = { ...data, _id: userId! };
            // Update property on form data
            setValue('_id', userId!);
          }
          // Notify
          notify(notificationMessage);
          // Close modal
          broadcastService.modal.hide();
          // Call callback function
          callback?.({ event: 'success', data: data as any });
        } catch (error) {
          // Update property on form data
          setValue('errorMessage', (error as Error)?.message);
          // Call callback function
          callback?.({ event: 'error', error });
        }
      }
    )();

  return (
    <DialogFooter>
      <div className='w-full flex justify-between'>
        <Button
          onClick={handleOnClickBtnCancel}
          disabled={isLoadingCreate || isLoadingEditCreator}
          variant='secondary'
          type='button'
          size={'sm'}>
          {
            textBtnCancel
              ? textBtnCancel
              : readonly
                ? 'Fermer'
                : 'Annuler'
          }
        </Button>
        {
          !readonly &&
          <Button
            onClick={handleOnClickBtnSave}
            disabled={!isValid || isLoadingCreate || isLoadingEditCreator || links.some(l => !l)}
            type='button'
            size={'sm'}>
            Enregistrer
          </Button>
        }
      </div>
    </DialogFooter>
  );

};

export default FormCreateOrEditCreatorFooter;
